import { type ConversationTurnItemConstructor } from '../../value-objects/ConversationTurnItem'
import { ConversationItemKinds } from '../../value-objects/enums'
import { type ConversationTranscriptEntryApiModel } from '../api-models/ConversationTranscriptApiModel'

export const mapConversationTranscriptApiModel = (
  entries: ConversationTranscriptEntryApiModel[]
): ConversationTurnItemConstructor[] =>
  entries
    .filter((entry) => entry.content !== '')
    .map((entry) => ({
      kind: ConversationItemKinds.MESSAGE,
      sender: entry.role === 'user' ? 'user' : 'llm',
      content: entry.content,
    }))
